import axios, { AxiosHeaders } from 'axios';
import AuthService from './AuthService';
import { ImpersonationStore } from './ImpersonationStore';

let registered = false;
const apiBase = String(process.env.REACT_APP_API_BASE || 'https://localhost:7192/api/').replace(/^['"]|['"]$/g, '');

export default function registerAxiosInterceptors() {
  if (registered) return;
  axios.interceptors.request.use(async (config) => {
    if (!String(config.url || '').startsWith(apiBase) || config.skipAuthorization) return config;
    const token = await AuthService.getAccessToken({ interactive: true });
    if (token) {
      config.headers = AxiosHeaders.from(config.headers);
      config.headers.set('Authorization', `Bearer ${token}`);
      const handle = ImpersonationStore.get()?.handle;
      if (handle) config.headers.set('X-Graduation-Impersonation', handle);
    }
    return config;
  });
  axios.interceptors.response.use((response) => response, (error) => {
    if (error?.response?.status === 401 && !error?.config?.skipAuthRedirect) {
      AuthService.logoutLocal();
      window.location.hash = '#/login';
    }
    return Promise.reject(error);
  });
  registered = true;
}
